import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取类别信息*/
export function GetCategory(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/category/",
        params:data
    })
}

/*获取类别编辑信息*/
export function CategoryEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/categoryedit/",
        params:data
    })
}

/*类别编辑*/
export function CategoryEdit(data = {}){
    let params = new URLSearchParams();
    params.append('categoryid',data.categoryid);
    params.append('categoryname',data.categoryname);
    params.append('categorydescription',data.categorydescription);
return instance.request({
        method: "post",
        url: "basicdata/categoryedit/",
        data:params
    })
}

/*类别新增*/
export function CategoryAdd(data = {}){
    let params = new URLSearchParams();
     params.append('categoryname',data.categoryname);
    params.append('categorydescription',data.categorydescription);
return instance.request({
        method: "post",
        url: "basicdata/categoryadd/",
        data:params
    })
}

/*类别删除*/
export function CategoryDel(data = {}){
    let params = new URLSearchParams();
    params.append('categoryid',data.categoryid)
return instance.request({
        method: "post",
        url: "basicdata/categorydel/",
        data:params
    })
}